import { BaseEitherError } from '@uniqkey-frontend/shared-app';

export class KeysManagerFetchPartnerKeysError extends BaseEitherError {}

export type TKeysManagerFetchPartnerKeysOperationErrors = KeysManagerFetchPartnerKeysError;
